/* 🤖 this file was generated by svg-to-ts */
export const siriusListBulletsDuotone: {
  name: 'list_bullets_duotone';
  data: string;
} = {
  name: 'list_bullets_duotone',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M5.25 6A1.125 1.125 0 1 1 3 6a1.125 1.125 0 0 1 2.25 0ZM8.25 5.25a.75.75 0 0 0 0 1.5h12a.75.75 0 0 0 0-1.5h-12ZM8.25 11.25a.75.75 0 0 0 0 1.5h12a.75.75 0 0 0 0-1.5h-12ZM7.5 18a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5h-12A.75.75 0 0 1 7.5 18ZM4.125 13.125a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25ZM5.25 18A1.125 1.125 0 1 1 3 18a1.125 1.125 0 0 1 2.25 0Z" fill="currentColor"/></svg>`
};
